import * as React from 'react';
import { Checkbox, Stack, FormControlLabel } from '@mui/material';
import { Check, Clear } from '@mui/icons-material';

export default function MixtureCheckbox(props) {
  
  function YesCheckBox() {
    return (
      <Checkbox 
        icon={<Check style={{ color: 'lightgrey' }} />}
        checkedIcon={<Check />}
        onChange={onYesChange}
        checked={props.mixture === 'true'}
      />
    );
  }
  
  function NoCheckBox() {
    return (
      <Checkbox 
        icon={<Clear style={{ color: 'lightgrey' }} />}
        checkedIcon={<Clear />}
        onChange={onNoChange}
        checked={props.mixture === 'false'}
      />
    );
  }

  function onYesChange(event) {
    console.log('Event YES: ', event.target.checked);
    if (event.target.checked) {
      props.setMixture('true');
    } else {
      props.setMixture(null);
    }
  }

  function onNoChange(event) {
    console.log('Event NO: ', event.target.checked);
    if (event.target.checked) {
      props.setMixture('false');
    } else {
      props.setMixture(null);
    }
  }

  return (
    <Stack direction='row' justifyContent='center'>
      <FormControlLabel control={<YesCheckBox />} label="Ja" labelPlacement="bottom" />
      <FormControlLabel control={<NoCheckBox />} label="Nein" labelPlacement="bottom" />
    </Stack>
  );
}